import React from 'react';
import styles from './styles.module.css';

export default ({ stages }) => (
  <nav className={styles.container}>
    <div className={styles.title}>Steps</div>
    <ul>
      {stages.map(({ name, active, disabled, onClick }, index) => (
        <li key={name}>
          <button
            id={`form-step-${index + 1}`}
            className={active ? styles.active : undefined}
            disabled={disabled}
            onClick={event => {
              event.preventDefault();
              onClick();
            }}
          >
            <span>{index + 1}</span>
            <span>{name}</span>
          </button>
        </li>
      ))}
    </ul>
  </nav>
);



// WEBPACK FOOTER //
// ./src/components/contribution-form/form-components/stage-progress/index.js